import React from 'react';
import DiscountFlagImage from '../DiscountFlagImage';

const getCreditCardInput = (props, i) => {
  return (
    <React.Fragment>
      <input
        type="radio"
        name="methodPayment"
        onChange={() => props.selectPaymentMethod(i)}
        checked={props.paymentMethods[i].selected}
        id={props.paymentMethods[i].class}
      />

      <DiscountFlagImage
        paymentMethod={props.paymentMethods[i]}
        content={
          <label htmlFor={props.paymentMethods[i].class}>
            <h4>
              {props.paymentMethods[i].name}
            </h4>
            <span>American Express, Visa, Mastercard, Elo, Diners Club Internacional, Hipercard</span>
          </label>
        }
      />
    </React.Fragment>
  );
};

export default getCreditCardInput;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/desktop/inputs/getCreditCardInput.jsx